import { gql } from "apollo-boost"

export const getTechnicalSpecification = gql`
  query TechnicalSpecification($id: ID!) {
    TechnicalSpecification(id: $id) {
      id
      name
      startDate
      endDate
      developmentObjective
      generalObjective
      state
      status
      specificObjectives {
        id
        orderIndex
        description
        indicators {
          id
          isBlocking
          type
          title
          orderIndex
          description
          methodology
          formula
          meansOfVerification
          orderIndex
          baseline
          goal
          startDate
          endDate
          measurementPeriodicity
          products
          metodologyDocuments {
            id
            name
            url
          }
        }
        activities {
          id
          isBlocking
          title
          orderIndex
          description
          responsible
          methodology
          formula
          meansOfVerification
          baseline
          goal
          place
          months
          inputs
          products
          schedules {
            id
            place
            scheduledAt
            completedAt
            startTime
            endTime
          }
          metodologyDocuments {
            id
            name
            url
          }
        }
      }
      developmentObjectiveIndicators {
        id
        type
        title
        description
        methodology
        formula
        meansOfVerification
        baseline
        goal
        startDate
        orderIndex
        endDate
        measurementPeriodicity
        products
        metodologyDocuments {
            id
            name
            url
          }
      }
      generalObjectiveIndicators {
        id
        type
        title
        description
        methodology
        orderIndex
        formula
        meansOfVerification
        baseline
        goal
        startDate
        endDate
        measurementPeriodicity
        products
        metodologyDocuments {
            id
            name
            url
          }
      }
    }
  }
`
